import { Api, Utility } from 'src/helpers/new';
import { IContact } from './Contact/Contact';
import { IBilling, IResidential } from './Billing/Billing';
import { isValidPhoneNumber } from 'react-phone-number-input';

export class CheckoutValidateHelper {
    static readonly validateEmail = (email: string) => {
        return Utility.validateEmail(email);
    };

    static validateContact(error: any, contact: IContact) {
        let proceed = true;
        const messages = { ...error };
        const { firstName, lastName, email, confirmEmail, phoneNumber } = contact;

        if (!email) {
            messages.emailMessage = 'Email cannot be empty.';
            proceed = false;
        } else if (email.length < 5) {
            messages.emailMessage = 'Email too short';
            proceed = false;
        } else if (email.length > 128) {
            messages.emailMessage = 'Email too long';
            proceed = false;
        } else if (!this.validateEmail(email)) {
            messages.emailMessage = 'Invalid email.';
            proceed = false;
        } else if (!this.validateEmail(confirmEmail) || email !== confirmEmail) {
            messages.confirmEmailMessage = 'Your email does not match. Please type it correctly.';
            proceed = false;
        }

        if (!firstName) {
            messages.firstNameMessage = 'First Name cannot be empty.';
            proceed = false;
        } else if (firstName.trim().length < 1) {
            messages.firstNameMessage = 'First name too short';
            proceed = false;
        } else if (firstName.length > 128) {
            messages.firstNameMessage = 'First name too long';
            proceed = false;
        }
        if (!lastName) {
            messages.lastNameMessage = 'Last Name cannot be empty.';
            proceed = false;
        } else if (lastName.trim().length < 1) {
            messages.lastNameMessage = 'Last name too short';
            proceed = false;
        } else if (lastName.length > 128) {
            messages.lastNameMessage = 'Last name too long';
            proceed = false;
        }

        if (!phoneNumber) {
            messages.phoneNumberMessage = 'Phone number cannot be empty.';
            proceed = false;
        } else if (phoneNumber) {
            if (!isValidPhoneNumber(phoneNumber)) {
                messages.phoneNumberMessage = 'Invalid phone number.';
                proceed = false;
            }
        }

        return {
            proceed,
            messages,
        };
    }

    static validateAddress(error: any, address: IBilling | IResidential, messagePrefix = '') {
        let proceed = true;
        const messages = { ...error };

        const { streetLines, town, state, zipCode, firstName, lastName } = address;

        const getMessageKey = (field: string) => {
            return messagePrefix
                ? `${messagePrefix}${field.charAt(0).toUpperCase()}${field.slice(1)}Message`
                : `${field}Message`;
        };

        if (!firstName) {
            messages[getMessageKey('firstName')] = 'First Name cannot be empty.';
            proceed = false;
        }

        if (!lastName) {
            messages[getMessageKey('lastName')] = 'Last Name cannot be empty.';
            proceed = false;
        }

        if ((streetLines && streetLines[0]?.length === 0) || !streetLines[0]) {
            messages[getMessageKey('addressLine')] = 'Address Line cannot be empty';
            proceed = false;
        }

        if (!town) {
            messages[getMessageKey('town')] = 'City cannot be empty';
            proceed = false;
        }

        if (!state || state === 'none') {
            messages[getMessageKey('state')] = 'State cannot be empty';
            proceed = false;
        }

        if (!zipCode) {
            messages[getMessageKey('zipCode')] = 'Zip code cannot be empty';
            proceed = false;
        }

        if (zipCode && !Utility.validateZipCode(zipCode)) {
            messages[getMessageKey('zipCode')] = 'Zip code allowed only for US origin';
            proceed = false;
        }

        return {
            proceed,
            messages,
        };
    }

    static validateBilling(error: any, billing: IBilling) {
        return this.validateAddress(error, billing);
    }

    static validateResidential(error: any, residential: IResidential) {
        return this.validateAddress(error, residential, 'residential');
    }
    static async checkEmail(email: string, userId: string) {
        const { response } = await Api.call('post', '/checkout/cart/createAccount/checkEmail', { email, userId });

        let inUse = false,
            canUse = true;
        if (response.userExists) {
            inUse = true;
            canUse = false;
        }

        if (response.userIsLoggedIn) {
            canUse = true;
        }
        return {
            inUse,
            canUse,
        };
    }
}
